const SupplierType = Object.freeze({
    SRM: 1,
    NonSRM: 2,
    Monitor: 3,
    NonSRMLite: 4,
  });

  export default SupplierType;
